module.exports = __webpack_public_path__ + "img/shougang-new.a9195e0c.png";